var _desc, _path, _path2, _path3, _path4, _path5, _path6, _path7;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgGitlabci(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 24 24",
    id: "Gitlab--Streamline-Svg-Logos",
    height: 24,
    width: 24,
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _desc || (_desc = /*#__PURE__*/React.createElement("desc", null, "Gitlab Streamline Icon: https://streamlinehq.com")), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "#e24329",
    d: "m11.999975 22.82365 4.327 -13.317075h-8.654l4.327 13.317075Z",
    strokeWidth: 0.25
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc6d26",
    d: "m12.000075 22.823625 -4.327 -13.317075H1.6088875L12.000075 22.823625Z",
    strokeWidth: 0.25
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    fill: "#fca326",
    d: "M1.60881 9.5066 0.2939125 13.55355c-0.1199335 0.3691 0.0114225 0.77345 0.32542 1.001575L12 22.823675 1.60881 9.5066Z",
    strokeWidth: 0.25
  })), _path4 || (_path4 = /*#__PURE__*/React.createElement("path", {
    fill: "#e24329",
    d: "M1.6088875 9.5066H7.673075L5.0669 1.485865c-0.134025 -0.4127675 -0.717925 -0.4126575 -0.85195 0L1.6088875 9.5066Z",
    strokeWidth: 0.25
  })), _path5 || (_path5 = /*#__PURE__*/React.createElement("path", {
    fill: "#fc6d26",
    d: "m12 22.823625 4.327 -13.317075h6.0642L12 22.823625Z",
    strokeWidth: 0.25
  })), _path6 || (_path6 = /*#__PURE__*/React.createElement("path", {
    fill: "#fca326",
    d: "m22.3912 9.5066 1.3149 4.04695c0.119925 0.3691 -0.011425 0.77345 -0.325425 1.001575L12 22.823675l10.3912 -13.317075Z",
    strokeWidth: 0.25
  })), _path7 || (_path7 = /*#__PURE__*/React.createElement("path", {
    fill: "#e24329",
    d: "M22.391225 9.5066H16.327025L18.9332 1.485865c0.13405 -0.4127675 0.717925 -0.4126575 0.85195 0L22.391225 9.5066Z",
    strokeWidth: 0.25
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgGitlabci);
export default __webpack_public_path__ + "static/media/gitlabci.ded4111f42b58617f16ff0255f7129e8.svg";
export { ForwardRef as ReactComponent };